import { Platform } from "./enums";
export default {
    supplierId: {
        type: "string",
    },
    platform: {
        inclusion: Object.values(Platform),
    },
};
